    import Axios from 'axios'
    import Store from '@/store/index'
    import Aplicacion from '@/controlador/aplicacion'
    import Tarea from '@/controlador/tarea'
    import Categoria from '@/controlador/categoria'
    import Router from '@/router'
    import Funciones from '@/funciones/index'

    const { checkrole, check_administrador } = Funciones

    const url_api = ()=>{ return Store.state.url_api }
    const token = ()=>{ return Store.state.token }
    const user = ()=>{ return Store.state.user }
    const work_area = ()=>{ return Store.state.workarea_actual }
    const proyecto_actual = ()=>{ return Store.state.proyecto_actual }
    const rol_actual = ()=>{ return Store.state.actual_rol }
    const login = ()=>{ return Store.state.login }

    const Workarea = {

        async index(){

            Aplicacion.loading(true)
         
            await Axios.get(`${url_api()}index_workarea`,{'headers':{'Authorization':`Bearer ${token()}`}})
            .then(response =>{
        
                Store.commit('set_workareas',response.data.areas)
                
                
                setTimeout(()=>{
                    
                    if(Store.state.work_areas.length){
                    
                        let workarea_str = localStorage.getItem('workarea_id') | 0
                        let workarea_id = parseInt(workarea_str)
                        let todas = Store.state.work_areas   
                        let bool_exists = todas.some((w)=>w.id == workarea_id)
                    
                        if(workarea_id >= 1 && bool_exists){
                            let area_select = todas.find((t)=> t.id == workarea_id)
                            this.clear(area_select)
                        }else{
                            Aplicacion.loading(false)
                        }
                    
                    }

                },500)

            })
            .catch(error => {
                console.log(error)
                window.location.reload()
            })
            .finally(()=>{})
        
        },

        async index_notificaciones(json){

            Aplicacion.mini_loading(true)
         
            await Axios.get(`${url_api()}index_notificaciones`,{'params':json,'headers':{'Authorization':`Bearer ${token()}`}})
            .then(response =>{
        
                Store.commit('set_notificaciones_eventos',response.data.notificaciones)
                Aplicacion.mini_loading(false)
    
            })
            .catch(error => {
                console.log(error)
                window.location.reload()
            })
            .finally()
        
        },

        async reset_counter_events(json){

            Aplicacion.mini_loading(true)
    
            await Axios.put(`${url_api()}reset_counter_events`,json,{'headers':{'content-type':'application/json','Authorization':`Bearer ${token()}`}})
            .then(response=>{
    
                if(response.data.errores == 0){
                    
                    Store.commit('set_notificaciones_contador',0)
                    Store.commit('set_notificaciones_eventos',[])
                    Store.dispatch('realizado')
                
                }
    
            })
            .catch(error => {
                console.log(error)
                window.location.reload()
            })
            .finally()
        },

        //# datos residuales al ingresar a una "workarea" #//
        async index_residual(json){

            await Axios.get(`${url_api()}index_residual_workarea`,{'params':json,'headers':{'content-type':'application/json','Authorization':`Bearer ${token()}`}})
            .then(response =>{

                if(response.data.errores == 0){
    
                    //set permisos roles
                    Store.commit('set_coordinador',response.data.coordinador.permisos)
                    Store.commit('set_ingeniero',response.data.ingeniero.permisos)
                    Store.commit('set_cliente',response.data.cliente.permisos)
                    Store.commit('set_gestor',response.data.gestor.permisos)
                    Store.commit('set_colaborador',response.data.colaborador.permisos)
                    Store.commit('set_actual_rol',response.data.rol)

                    //set categorias
                    Store.dispatch('add_categorias_store', response.data.categorias)

                    //set notificaciones report
                    Store.commit('set_notificaciones_contador',response.data.notificaciones_count)

                    //set datos residuales del usuario 
                    let user_data = Store.state.user_data //{'t_ideas':0,'t_retos':0,'t_puntos':0,'redimidos':0}
                    user_data.t_ideas = response.data.t_ideas
                    user_data.t_retos = response.data.t_retos
                    user_data.t_puntos = response.data.valor_puntos.puntos
                    user_data.redimidos = response.data.valor_puntos.Redimidos //la clave "Redimidos" quedó en mayuscula en la db, sorry
                    
                    Store.commit('set_user_data',user_data)

                    setTimeout(()=>{ 
                        
                        if(checkrole('workarea','blog')){
                            Aplicacion.set_section_num([0,1]) //sección,ecabezado
                        }
                        else if(checkrole('proyectos','read')){
                            Aplicacion.set_section_num([2,2])
                        }

                        Aplicacion.loading(false)

                    },500)

                }

            })
            .catch(error => {
                console.log(error)
                window.location.reload()
            })
            .finally()

        },

        async store_permisos(json){

            Aplicacion.loading(true)

            await Axios.put(`${url_api()}store_permisos`,json,{'headers':{'content-type':'applicaction/json','Authorization':`Bearer ${token()}`}})
            .then(response => {

                Aplicacion.loading(false)

                if(json.rol == 'coordinador'){ Store.commit('set_coordinador',response.data.permisos.permisos) }
                if(json.rol == 'ingeniero'){ Store.commit('set_ingeniero',response.data.permisos.permisos) }
                if(json.rol == 'cliente'){ Store.commit('set_cliente',response.data.permisos.permisos) }
                if(json.rol == 'gestor'){ Store.commit('set_gestor',response.data.permisos.permisos) }
                if(json.rol == 'colaborador'){ Store.commit('set_colaborador',response.data.permisos.permisos) }

                if(response.data.errores == 0){
                    Aplicacion.notificar_realizado('Permisos Actualizados')
                }

            })
            .catch(error => {
                console.log(error)
                window.location.reload()
            })
            .finally()

        },

        async index_blogs(json){

            Aplicacion.loading(true)
 
            await Axios.get(`${url_api()}index_blogs`,{'params':json,'headers':{'Authorization':`Bearer ${token()}`}})
            .then(response =>{

                Store.commit('set_blogs',response.data.blogs)
                Aplicacion.loading(false)

            })
            .catch(error => {
                console.log(error)
                window.location.reload()
            })
            .finally()

        },

        async store_favorito(json){

            Aplicacion.mini_loading(true)
    
            await Axios.put(`${url_api()}store_favorite_workarea`,json,{'headers':{'content-type':'application/json','Authorization':`Bearer ${token()}`}})
            .then(response=>{
    
                if(response.data.errores == 0){
                    Store.dispatch('realizado')
                }
    
                if(response.data.errores == 400){
    
                    var nlocal ={
                        'run':true,
                        'tipo':'advertencia',
                        'titulo': user().email,
                        'contenido':'Workarea no exists!',
                        'errores':[],
                        'tiempo':5000,
                        'cerrar':false
                    }
    
                    Aplicacion.mini_loading(false)
                    Store.commit('set_notificacion_local',nlocal)
                }
    
                if(response.data.errores == 300){
                    
                    var nlocal ={
                        'run':true,
                        'tipo':'advertencia',
                        'titulo': user().email,
                        'contenido':'Already exists!',
                        'errores':[],
                        'tiempo':5000,
                        'cerrar':false
                    }
    
                    Aplicacion.mini_loading(false)
                    Store.commit('set_notificacion_local',nlocal)
                }
    
            })
            .catch(error => {
                console.log(error)
                window.location.reload()
            })
            .finally()
        },

        async delete_favorito(json){
    
            Aplicacion.mini_loading(true)
    
            await Axios.put(`${url_api()}delete_favorite_workarea`,json,{'headers':{'content-type':'application/json','Authorization':`Bearer ${token()}`}})
            .then(response=>{
    
                if(response.data.errores == 0){
                    Store.dispatch('realizado')
                }
    
                if(response.data.errores == 300){
    
                    var nlocal ={
                        'run':true,
                        'tipo':'advertencia',
                        'titulo': user().email,
                        'contenido':'No favorite found!',
                        'errores':[],
                        'tiempo':5000,
                        'cerrar':false
                    }
    
                    Aplicacion.mini_loading(false)
                    Store.commit('set_notificacion_local',nlocal)
                }
    
            })
            .catch(error => {
                console.log(error)
                window.location.reload()
            })
            .finally()
    
        },

        async clear(json){

            Aplicacion.loading(true)
    
            await Store.dispatch('clean_workarea')
            .then(response =>{

                if(response >= 1){ 
                    window.location.reload() 
                }
                else{

                    //localStorage.setItem('workarea',JSON.stringify(json))
                    localStorage.setItem('workarea_id',json.id)

                    Store.commit('set_workarea_actual',json) 

                    var nlocal ={
                        'run':true,
                        'tipo':'informativo',
                        'titulo':'Organization "'+ json.organizacion +'" was selected!',
                        'contenido':'You have '+ json.proyectos_count_vinculados +' projects vinculated.',
                        'errores':[],
                        'tiempo':4000,
                        'cerrar':true
                    }
            
                    var nglobal ={
                        'run':true,
                        'titulo':'Organization '+ json.organizacion +' was selected' ,
                        'contenido':'You have '+ json.proyectos_count_vinculados +' projects vinculated!',
                        'icono':'https://asakaa.com/images/mini_logo.svg'
                    }
            
                    //global
                    //Store.commit('set_notificacion_global',nglobal)
            
                    //local
                    //Store.commit('set_notificacion_local',nlocal)

                    this.index_residual({'workarea_id':json.id})

                }

            })
            .catch(error => {
                console.log(error)
                window.location.reload()
            })
            .finally()

        }
        
    }

    export default Workarea